(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vuetify/lib"), require("date-fns"));
	else if(typeof define === 'function' && define.amd)
		define(["vuetify/lib", "date-fns"], factory);
	else if(typeof exports === 'object')
		exports["vuetify-daterange-picker"] = factory(require("vuetify/lib"), require("date-fns"));
	else
		root["vuetify-daterange-picker"] = factory(root["vuetify/lib"], root["date-fns"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__4875__, __WEBPACK_EXTERNAL_MODULE_f413__) {
return 